//////////////////////////////////////////////////////////////
//     							                                        //
//  Program: CheckinHouseRuleService.js                     //
//  Application: CheckinHouseRuleService                    //
//  Option: Used to manage a property's itemized check-in    //
//          house rules                                      //
//  Date: 2026-07-09                                        //
//                                                          //
//////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

// Method names are UI-facing only. The endpoint strings below are the real
// backend routes (Task 5.2/5.3's frozen API contract) and must not change.
class CheckinHouseRuleService {
  getCheckinHouseRules(propertySlug) {
    let endPoint = "get-property-house-rule/" + propertySlug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  addOrUpdateCheckinHouseRules(data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "add-update-property-house-rule";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }
}

export default new CheckinHouseRuleService();
